// @ts-nocheck
import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import Vue from 'vue'
import 'babel-polyfill'
import App from './app'
import Vuetify from 'vuetify'
import router from '@router'
import store from '@state/store'
import '@components/_globals'
import Highcharts from 'highcharts'
import loadExporting from 'highcharts/modules/exporting'
import Type from 'union-type'

loadExporting(Highcharts)
Highcharts.SVGRenderer.prototype.symbols.download = function(x, y, w, h) {
  var path = [
    // Arrow stem
    'M',
    x + w * 0.5,
    y,
    'L',
    x + w * 0.5,
    y + h * 0.7,
    // Arrow head
    'M',
    x + w * 0.3,
    y + h * 0.5,
    'L',
    x + w * 0.5,
    y + h * 0.7,
    'L',
    x + w * 0.7,
    y + h * 0.5,
    // Box
    'M',
    x,
    y + h * 0.9,
    'L',
    x,
    y + h,
    'L',
    x + w,
    y + h,
    'L',
    x + w,
    y + h * 0.9,
  ]
  return path
}

// Don't warn about using the dev version of Vue in development
Vue.config.productionTip = process.env.NODE_ENV === 'production'
Vue.use(Vuetify)

const app = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

// If running inside Cypress
if (window.Cypress) {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`
  window.__app__ = app
}

if (process.env.NODE_ENV === 'development') {
  window.R = require('ramda')
  window.HighCharts = require('highcharts')
} else {
  Type.check = false
}
